var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-summary-payment"},[(Object.keys(_vm.dataResponse).length)?_c('data-summary-payment',{attrs:{"data-response":_vm.dataResponse,"products":_vm.products}}):(
      !_vm.$store.state.loaderDerek && Object.keys(_vm.dataResponse).length == 0
    )?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }